import classnames from 'classnames';
import T from 'prop-types';
import React, { Component } from 'react';
import ReactQuill from 'react-quill';

export default class RichTextEditor extends Component {
  static propTypes = {
    onChange: T.func,
    value: T.string,
    invalid: T.bool,
    formats: T.arrayOf(T.string),
    toolbar: T.array,
    readOnly: T.bool,
  };

  static defaultProps = {
    value: '',
    invalid: false,
    formats: ['bold', 'italic', 'link', 'list'],
    toolbar: ['bold', 'italic', 'link', { list: 'ordered' }, { list: 'bullet' }, 'clean'],
    readOnly: false,
  };

  constructor(props, ...args) {
    super(props, ...args);

    const { value } = props;

    if (typeof value === 'string') {
      this.state.value = value;
    }
  }

  state = {
    value: '',
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { value } = this.state;

    if (value !== nextProps.value) {
      this.setState({
        value: nextProps.value,
      });
    }
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.value !== this.props.value;
  }

  onChange = value => {
    if (value !== this.state.value) {
      this.setState({ value });
      if (typeof this.props.onChange === 'function') {
        this.props.onChange(value);
      }
    }
  };

  render() {
    const { value } = this.state;

    const modules = {
      toolbar: this.props.toolbar,
      clipboard: { matchVisual: false },
    };

    return (
      <div
        className={classnames('rich-text-editor', {
          'rich-text-editor--invalid': this.props.invalid,
        })}
      >
        <ReactQuill
          theme="snow"
          value={value}
          modules={modules}
          onChange={this.onChange}
          formats={this.props.formats}
          readOnly={this.props.readOnly}
        />
      </div>
    );
  }
}
